import React from 'react';

import * as S from './styles';

function Check({ label, checked, isTitle = false }) {
    return (
        <S.Container isTitle={!!isTitle}>
            {label && (
                <S.Check>
                    <S.Square checked={!!checked} />
                    <S.Label isTitle={!!isTitle}>{label}</S.Label>
                </S.Check>
            )}
        </S.Container>
    );
}
export default Check;
